import {
  createBusinessProfileStatus,
  deleteBusinessProfileStatus,
  updateBusinessProfileStatus,
} from '@store/business/BusinessProfileStatusReducer'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

export const BusinessStatusForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const { error } = useAppSelector((state) => state.businessProfileStatus)
  const dispatch = useAppDispatch()

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        create: Create,
        update: Update,
        delete: Delete,
      }}
      handlers={{
        create: async (values) =>
          dispatch(createBusinessProfileStatus(values)).then(() => {
            return true
          }),
        update: async (values) =>
          dispatch(updateBusinessProfileStatus(values)).then(() => {
            return true
          }),
        delete: async (values) =>
          dispatch(deleteBusinessProfileStatus(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

BusinessStatusForm.displayName = 'BusinessStatusForm'

export default BusinessStatusForm
